
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import { AuthService } from "@/services/auth-service";
import { BackupService } from "@/services/backup-service";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";

export default FormLike.extend({
	data(){
		return {
			file: null as null | File,
			encryptionKey: "",
			isUploadingFile: false
		};
	},
	computed: {
		isSupport():boolean {
			return AuthService.isDevModeEnabled;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		onFile(file:File){
			this.file = file;
			this.isValid = false;
			this.validateFile(file);
		},
		removeFile(){
			this.file = null;
			this.isValid = false;
		},
		async validateFile(file:File){
			try{
				let result = await BackupService.validate(file, this.encryptionKey);
				this.isValid = result.Valid;
				if (result.DBVersionIncorrect) {
					let text = this.$ct("backup-db-version-incorrect-warning");
					await this.$wf.dialog(text, this.$ct("common.ok"), this.$ct("common.warning"), "warning");
				}
			}catch(err){
				this.file = null;
			}
		},
		async confirm(){
			if (!this.isValid) return;
			if (this.isUploadingFile) return;
			let confirmText = this.$ct("are-you-sure-you-want-to-restore-backup");
			let confirm = await this.$wf.confirm(confirmText, this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.warning"), "warning");
			if (!confirm) return;
			if (!this.file) return;
			this.isUploadingFile = true;
			try{
				await BackupService.restoreBackup(this.file, this.encryptionKey);
				this.close();
			}catch(err) {

			}
			this.isUploadingFile = false;
		}
	},
	components: {
		AppFileUpload
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
